import { combineReducers } from 'redux';

import actionTypes from '@atom/actions/actionTypes';

import arcgisLayerData from './arcgisLayerDataReducer';
import auth from './authReducer';
import formInstance from './formInstanceReducer';
import formTemplateDetail from './formTemplateDetailReducer';
import formTemplates from './formTemplatesReducer';
import formTemplatesTotal from './formTemplatesTotalReducer';
import initialState from './initialState';
import exportTemplateDetail from './inventoryExportTemplateDetailReducer';
import exportTemplates from './inventoryExportTemplatesReducer';
import inventoryFilterCategoryTree from './inventoryFilterCategoryTreeReducer';
import inventoryFullCategoryTree from './inventoryFullCategoryTreeReducer';
import inventoryNavigation from './inventoryNavigationReducer';
import inventory from './inventoryReducer';
import inventorySchemaDetail from './inventorySchemaDetailReducer';
import inventorySchema from './inventorySchemaReducer';
import inventorySchemasByIds from './inventorySchemasByIdsReducer';
import inventorySchemas from './inventorySchemasReducer';
import inventorySchemaTree from './inventorySchemaTreeReducer';
import inventoryTotal from './inventoryTotalReducer';
import loading from './loadingReducer';
import mediaFolders from './mediaFoldersReducer';
import mediaFolderTree from './mediaFolderTreeReducer';
import media from './mediaReducer';
import mediaTotal from './mediaTotalReducer';
import mediaTotals from './mediaTotalsReducer';
import organizations from './organizationsReducer';
import poolAttributes from './poolAttributesReducer';
import preferences from './preferencesReducer';
import teamNavigation from './teamNavigationReducer';
import userProfile from './userProfileReducer';
import workOrdersInput from './workOrdersInputReducer';
import workTemplates from './workTemplatesReducer';
import workTemplatesTotal from './workTemplatesTotalReducer';
import workTemplatesView from './workTemplatesViewReducer';
import workValidations from './workValidationsReducer';

const applicationReducer = combineReducers({
  arcgisLayerData,
  auth,
  exportTemplateDetail,
  exportTemplates,
  formInstance,
  formTemplateDetail,
  formTemplates,
  formTemplatesTotal,
  inventory,
  inventoryFilterCategoryTree,
  inventoryFullCategoryTree,
  inventoryNavigation,
  inventorySchema,
  inventorySchemaDetail,
  inventorySchemas,
  inventorySchemasByIds,
  inventorySchemaTree,
  inventoryTotal,
  loading,
  media,
  mediaFolders,
  mediaFolderTree,
  mediaTotal,
  mediaTotals,
  organizations,
  poolAttributes,
  preferences,
  teamNavigation,
  userProfile,
  workOrdersInput,
  workTemplates,
  workTemplatesTotal,
  workTemplatesView,
  workValidations,
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.LOGOUT_SUCCESS) {
    // eslint-disable-next-line no-param-reassign
    state = initialState;
  }

  return applicationReducer(state, action);
};

export default rootReducer;
